var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 56,
    viewBox: "0 0 140 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.0207 20C86.0207 4 113.521 -1.5 142.021 -2V68.5C96.0207 71.1667 4.42069 73.4 6.02069 61C8.02069 45.5 26.5207 38.5 40.5207 39.5C54.5207 40.5 62.0207 36 74.0207 20Z",
    fill: "#F8DBB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.414 56.4827L42.0984 56.5225C39.6935 56.5225 37.7617 54.5735 37.7617 52.1472L109.751 52.1074C109.751 54.5337 107.819 56.4827 105.414 56.4827Z",
    fill: "#3D5AC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.414 54.9713L42.0984 55.011C40.2455 55.011 38.6291 53.8178 38.0377 52.1472H37.7617C37.7617 54.5735 39.6935 56.5225 42.0984 56.5225L105.414 56.4827C107.819 56.4827 109.751 54.5337 109.751 52.1074H109.475C108.883 53.778 107.306 54.9713 105.414 54.9713Z",
    fill: "#5571E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8564 53.6182H69.6955C68.907 53.6182 68.2368 52.9818 68.2368 52.1465H79.3151C79.3151 52.942 78.6449 53.6182 77.8564 53.6182Z",
    fill: "#27429C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.045 52.1078L41.4676 52.1476L41.4282 12.8098C41.4282 10.5426 43.2417 8.71289 45.4889 8.71289H101.984C104.231 8.71289 106.045 10.5426 106.045 12.8098V52.1078Z",
    fill: "#5571E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.694 12.1348H44.8187V48.7679H102.694V12.1348Z",
    fill: "#312C76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.733 45.2266H44.8582V48.7268H102.733V45.2266Z",
    fill: "#151247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.694 12.1348H44.8187V13.8849H102.694V12.1348Z",
    fill: "#151247"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M64.0973 12.1328L44.8187 31.6227L44.8581 48.7659H44.8976L81.1287 12.1328H64.0973Z",
    fill: "#5571E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M52.3094 48.7667H60.8645L97.135 12.0938L88.5799 12.1335L52.3094 48.7667Z",
    fill: "#5571E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M95.8734 48.7275L102.694 41.8464V28.8398L82.272 48.7275H95.8734Z",
    fill: "#5571E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.084 27.7656H41.4677V34.965H106.084V27.7656Z",
    fill: "#F5D100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5984 34.8665H43.8904L48.7888 27.7832H54.4968L49.5984 34.8665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0887 34.8665H55.3807L60.2791 27.7832H65.9871L61.0887 34.8665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4412 34.8665H67.7549L72.675 27.7832H78.3613L73.4412 34.8665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9315 34.8665H79.2452L84.1653 27.7832H89.8516L84.9315 34.8665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8518 34.8665H91.6194L96.1096 27.7832H101.342L96.8518 34.8665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3962 59.0601L33.3818 57.3895L32.3962 55.5996L31.0164 58.3043L32.3962 59.0601Z",
    fill: "#EB8175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0445 49.276C40.0445 49.276 34.8011 47.7646 34.2886 49.1965C33.776 50.6284 30.7009 56.9527 30.7009 56.9527L32.9875 58.146L36.4175 52.1399L41.0301 51.7421L40.0445 49.276Z",
    fill: "#14103D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7542 49.0371L35.7867 49.2758C35.7867 49.2758 35.0771 49.3155 35.1165 50.9861C35.1559 52.6567 35.1559 59.4582 35.1559 59.4582L37.5214 59.5378L37.9945 52.418L42.962 52.3385C44.0264 52.3385 44.9726 51.7021 45.4063 50.7474C45.564 50.3895 45.6428 49.9519 45.5246 49.5144L40.7542 49.0371Z",
    fill: "#231C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0626 48.043C36.0626 48.5203 35.7472 48.5999 35.2741 48.5999C34.801 48.5999 34.3674 48.5203 34.3674 48.043C34.3674 47.5657 34.7616 47.168 35.2347 47.168C35.6684 47.168 36.0626 47.5657 36.0626 48.043Z",
    fill: "#E1AD9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.654 48.521H35.6683C35.3924 48.521 35.1953 48.3221 35.1953 48.0437C35.1953 47.7653 35.3924 47.5664 35.6683 47.5664H36.654C36.9299 47.5664 37.1271 47.7653 37.1271 48.0437C37.1271 48.2824 36.9299 48.521 36.654 48.521Z",
    fill: "#E1AD9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6146 48.6L36.2992 46.9692L40.3599 46.5316L41.1878 41.7586C41.2667 41.3211 41.8975 40.804 42.3311 40.8835L42.2129 40.8438C42.6465 40.9233 43.0408 41.4404 42.9619 41.8779L42.1734 47.6056C42.134 47.9238 41.8975 48.1624 41.5821 48.242L36.6146 48.6Z",
    fill: "#C8C6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6966 41.0036C44.7754 41.0036 44.8543 41.0433 44.9331 41.0433H44.9726C45.6822 41.3218 46.1553 42.0775 46.1553 42.7935L45.5245 49.5553C41.3455 49.5155 40.7147 49.0382 40.7147 49.0382L41.0301 42.1173C41.0695 41.4809 41.3849 40.8445 42.134 40.8047L44.6966 41.0036Z",
    fill: "#D8D7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0839 48.5602C40.1233 49.0375 39.808 49.1171 39.3349 49.1569C38.8618 49.1966 38.4281 49.1569 38.3887 48.6796C38.3492 48.2023 38.7041 47.8045 39.1772 47.7647C39.6503 47.725 40.0445 48.0829 40.0839 48.5602Z",
    fill: "#EB8175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7147 48.9976L39.7291 49.0771C39.4531 49.0771 39.256 48.8782 39.2166 48.6396C39.2166 48.3612 39.4137 48.1623 39.6502 48.1225L40.6358 48.043C40.9118 48.043 41.1089 48.2418 41.1484 48.4805C41.1878 48.7589 40.9907 48.9976 40.7147 48.9976Z",
    fill: "#EB8175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6753 49.1179L40.2416 47.5269L44.6572 46.8109L44.4206 42.6743C44.4601 42.2367 44.9332 41.7594 45.3668 41.7992C45.8005 41.839 46.2342 42.3163 46.1947 42.7538L46.5101 47.7257C46.4707 48.0439 46.2736 48.2826 45.9582 48.4019L40.6753 49.1179Z",
    fill: "#D8D7FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0664 43.5879L37.8761 44.0652C38.0338 44.0652 38.1521 44.2243 38.1915 44.3834L38.7041 48.7587C38.7435 48.9576 38.5464 49.1565 38.3492 49.1167L33.4606 48.6394C33.3029 48.6394 33.1846 48.4803 33.1452 48.3212L32.7115 43.9459C32.6721 43.747 32.8298 43.5879 33.0664 43.5879Z",
    fill: "#091218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7904 43.5891L37.6002 44.0267C37.7579 44.0267 37.8762 44.1858 37.9156 44.3449L38.4281 48.7202C38.4675 48.919 38.2704 49.1179 38.0733 49.0781L33.1847 48.6008C33.027 48.6008 32.9087 48.4417 32.8693 48.2826L32.4356 43.9073C32.3962 43.7482 32.5539 43.5494 32.7904 43.5891Z",
    fill: "#1B2934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5464 48.7598L41.8186 49.078C41.9369 49.078 41.9763 49.1575 41.9763 49.2768C41.9763 49.3962 41.8974 49.4359 41.7792 49.4359L38.3098 49.1177L38.5464 48.7598Z",
    fill: "#091218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5501 46.2553C35.5107 46.5337 35.2741 46.7724 34.9587 46.7326C34.6828 46.6928 34.4462 46.4542 34.4856 46.136C34.5251 45.8575 34.7616 45.6189 35.077 45.6586C35.353 45.6984 35.5501 45.9371 35.5501 46.2553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2629 43.5898L44.3812 46.7321L40.2416 47.4878L43.8687 46.3741L44.2629 43.5898Z",
    fill: "#C8C6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0946 40.5652L42.3706 41.321C42.4888 41.5994 42.7254 41.7585 43.0014 41.7983C43.5533 41.838 43.9081 41.2812 43.711 40.8039L43.2379 39.6504L42.0946 40.5652Z",
    fill: "#EB8175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3311 41.2415C42.3311 41.2415 43.6716 40.9631 43.4745 39.7698C43.2773 38.5766 42.0157 39.4914 42.0157 39.4914L42.134 40.6847L42.3311 41.2415Z",
    fill: "#E16C5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2417 37.6633C39.7291 38.7373 40.2022 40.0101 41.2667 40.5272C42.3312 41.0443 43.5927 40.5669 44.1053 39.493C44.6178 38.4191 44.1447 37.1463 43.0802 36.6292C42.0158 36.1121 40.7148 36.5894 40.2417 37.6633Z",
    fill: "#EB8175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.962 38.9748C42.962 38.9748 42.6466 40.6852 43.8687 40.725C45.1303 40.7647 44.4207 37.5032 44.4207 37.5032L42.4494 35.4746L39.4138 36.2303L39.7292 38.2191C39.7292 38.2191 40.2022 38.4578 42.8043 38.06L42.962 38.9748Z",
    fill: "#231C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7004 37.6621L42.7254 39.094L43.5533 38.1394L41.7004 37.6621Z",
    fill: "#231C61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6071 38.578C42.4494 38.8962 42.6071 39.2541 42.8831 39.3735C43.1985 39.5326 43.5533 39.3735 43.6716 39.095C43.8293 38.7768 43.6716 38.4189 43.3956 38.2995C43.1197 38.1404 42.7648 38.2995 42.6071 38.578Z",
    fill: "#EB8175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.808 38.2192C39.808 38.2192 39.3349 36.5089 40.4388 35.4747C41.3455 34.5997 42.8043 34.6792 43.5927 35.6338C43.9476 36.0714 44.263 36.7475 44.3024 37.7817L39.808 38.2192Z",
    fill: "#F5D100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0446 38.1789V37.105C40.0446 36.8265 40.2417 36.6277 40.5177 36.5879C40.7936 36.5879 40.9907 36.7868 41.0302 37.0254L41.1484 38.0596",
    stroke: "#F1AB00",
    strokeWidth: 0.2802,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3024 37.7812L39.4138 38.2585",
    stroke: "white",
    strokeWidth: 1.1206,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5747 55.5691L54.4777 45.4263C54.6748 44.949 55.3451 44.949 55.5422 45.4263L59.4452 55.5691H50.5747Z",
    fill: "#F5D100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3808 47.6133H51.4815V49.7611H58.3808V47.6133Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9327 51.6719H51.1266V53.8197H58.9327V51.6719Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1548 55.5684H49.8651V56.4434H60.1548V55.5684Z",
    fill: "#E8C400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.109 55.6081L111.012 45.4654C111.21 44.9881 111.88 44.9881 112.077 45.4654L115.98 55.6081H107.109Z",
    fill: "#F5D100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.915 47.6133H108.016V49.7611H114.915V47.6133Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.428 51.7109H107.622V53.8588H115.428V51.7109Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.689 55.6074H106.4V56.4825H116.689V55.6074Z",
    fill: "#E8C400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.2015d294e09f8145d94f772ce34306a7.svg";
export { ForwardRef as ReactComponent };